import Card from '../../../component/card/Card.component';
import { FormatDateHours } from '../../../utils/format/FormatDate';
import ButtonLink from '../../../component/buttton/ButtonLink.component';
import FontBold from '../../../component/fontBold/FontBold.component';
import GridComponent from '../../../component/grid/GridComponent.component';
import Grid from '@material-ui/core/Grid';
import Notification from '../interfaces/Notification';
import { memo } from 'react';
import { HeightText } from '../../../component/heightText/HeightText.component';

interface CardComponentInterface {
    notification: Notification;
    title: string;
    close?: boolean;
}

const CardComponent = ({ title, notification, close }: CardComponentInterface) => {


    return (
        <Grid item xs={12} sm={6} md={6} lg={4} xl={3} >
            <Card color="#FBFBFB" padding='10px 20px 10px 20px' >
                <GridComponent direction='column' alignItems='flex-start'>
                    <HeightText>
                        <FontBold title={title} isUpperCase={true} color='#095AA5' fontSize={20} />
                    </HeightText>
                    {!close && (
                        <>
                            <HeightText>
                                <FontBold title="UUNN Afetadas: " subTitle={notification.UUNNStoresAffected.substring(0, 30)} />
                            </HeightText>
                            <HeightText height={110}>
                                <FontBold title="Impacto Inicial: " subTitle={notification.initialImpact} />
                            </HeightText>
                        </>
                    )}
                    {close && (
                        <HeightText>
                            <FontBold title="Falha: " subTitle={notification.serviceHealthBusiness} />
                        </HeightText>
                    )}
                    <FontBold title="Criado em: " subTitle={FormatDateHours(notification.created_at)} />
                    {close && <FontBold title="Finalizado Em: " subTitle={FormatDateHours(notification.ImNotificationTime)} />}
                    {!close && <FontBold title="Criado por: " subTitle={notification.loginCreated} />}

                    <ButtonLink title="abrir" link={`/notificacao/${close ? 'close/' : ''}view-notificacao/${notification.id}`} size='medium' />

                </GridComponent>
            </Card>
        </Grid>
    )
}

export default memo(CardComponent);